import "./EditableEntries.css";
import {display_pair, edit_pair} from "./constants";
import EditableEntryTimezone from "./EditableEntryTimezone";
import {useId} from "react";
import {SC_GeoLocation} from "../../util/api/SC_GeoLocation";

/**
 * @param baseValue {SC_Address}
 * @param onEdit
 * @param isEditing
 * @param displayLabel
 * @return {JSX.Element}
 * @constructor
 */
const EditableCardEntryAddress = ({baseValue, onEdit, isEditing, displayLabel, prefix = "", timezone = false, latlon = true, smaller = false}) => {
    const idRoot = useId();

    return (
        <>
            {isEditing ? (
                <div>
                    <div className={edit_pair}>
                        <label htmlFor={`${idRoot}-street-line-1`}>{prefix}Street Line 1</label>
                        <input
                            id={`${idRoot}-street-line-1`}
                            alt={"First street address line"}
                            type={"text"}
                            value={baseValue.street_1}
                            onChange={(e) => onEdit({street_1: e.target.value})}
                        />
                    </div>
                    <div className={edit_pair}>
                        <label htmlFor={`${idRoot}-street-line-2`}>{prefix}Street Line 2</label>
                        <input
                            id={`${idRoot}-street-line-2`}
                            type={"text"}
                            value={baseValue.street_2}
                            onChange={(e) => onEdit({street_2: e.target.value})}
                        />
                    </div>
                    <div className={edit_pair}>
                        <label htmlFor={`${idRoot}-city`}>{prefix}City</label>
                        <input
                            id={`${idRoot}-city`}
                            type={"text"}
                            value={baseValue.city}
                            onChange={(e) => onEdit({city: e.target.value})}
                        />
                    </div>
                    <div className={edit_pair}>
                        <label htmlFor={`${idRoot}-state`}>{prefix}State</label>
                        <input
                            id={`${idRoot}-state`}
                            type={"text"}
                            value={baseValue.state}
                            onChange={(e) => onEdit({state: e.target.value})}
                        />
                    </div>
                    <div className={edit_pair}>
                        <label htmlFor={`${idRoot}-zip`}>{prefix}Zip</label>
                        <input
                            id={`${idRoot}-zip`}
                            type={"text"}
                            value={baseValue.zip}
                            onChange={(e) => onEdit({zip: e.target.value})}
                        />
                    </div>
                    {latlon ? <div className={edit_pair}>
                        <label htmlFor={`${idRoot}-coords`}>{prefix}Coordinates</label>
                        <input
                            id={`${idRoot}-coords`}
                            type={"text"}
                            defaultValue={baseValue.geoLocation.truthy ? baseValue.geoLocation.latitude.toFixed(7) + ", " + baseValue.geoLocation.longitude.toFixed(7) : undefined}
                            onChange={(e) => {
                                let newText = e.target.value;

                                let newCoords = baseValue.geoLocation;
                                let regelex;

                                if (newText === "")
                                    newCoords = new SC_GeoLocation();
                                else if ((regelex = newText.match(/(\d+\.\d+),\s*(-\d+\.\d+)/)))
                                    newCoords = new SC_GeoLocation(Number(regelex[1]), Number(regelex[2]));

                                onEdit({geoLocation: newCoords});
                            }}
                        />
                    </div> : null}
                    {timezone ? <EditableEntryTimezone baseValue={baseValue.timezone_id} isEditing={true} onEdit={(v) => v !== -1 ? onEdit({timezone_id: v}) : null}/> : null}
                </div>
            ) : (
                <div className={display_pair}>
                    <span>{displayLabel}</span>
                    <span className={"editable-entry-payload"}>
                    <a style={smaller ? {fontSize: '0.875rem'} : {}} target={"_blank"} href={baseValue.googleMapsLink()}>
                    {baseValue.street_1}{baseValue.street_2 &&
                        <>
                            <br/>{baseValue.street_2}
                        </>}<br/>
                        {baseValue.city && `${baseValue.city}, `}{baseValue.state && `${baseValue.state} `}{baseValue.zip && baseValue.zip}
                    </a>
                    </span>
                </div>
            )}
        </>
    )
}

export default EditableCardEntryAddress;